import {Task, TaskLevel} from 'app/entities/Task';
import {ExternalFilter} from './ExternalFilter';

export enum TaskTypes {UnPlanned = 0, Planned = 1, All = 5};

export enum ViewNames {timelineWeek = 0, allDayWeekTimeline = 1};

export enum FilterTypes {All = 0, External = 1, Placed};

export class TaskPageModel {
  PageSize: number;
  PageIndex: number;
  TotalCount: number;
  Tasks: Task[];
  UserID: number;
  Type: number;
  CalendarFilter: number;
  JobNo: string;
  TaskNo: string;
  SearchInput: string;
  FilterType: FilterTypes;
  // Maintenance
  FromDate: string;
  ToDate: string;
  ResponsibleNo: string;
  CategoryEntryNo: number;
  TaskStatus: string;
  ExternalFilter: ExternalFilter;
  TaskLevel?: TaskLevel;
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/entities/PageModel.ts